import React, { useState, useEffect } from "react";
import { ReactComponent as CancelIcon } from "assets/img/icons/cancel.svg";
import Scrollbar from "react-scrollbars-custom";
import { CSSTransition } from "react-transition-group";
import ClickAwayListener from "react-click-away-listener";
import { ReactComponent as Add } from "assets/img/icons/addSvg.svg";
import classNames from "classnames";

export default ({
  filterData,
  members,
  selectMembers,
  setSelectMembers,
  fieldName,
}) => {
  const [showMembers, setShowMembers] = useState(false);
  const [allMembers, setAllMembers] = useState(members);

  useEffect(() => {
    if (selectMembers.length === 0) {
      return;
    }

    setAllMembers(
      members.filter((el) => {
        return !selectMembers.find((element) => {
          return element.id === el.id;
        });
      })
    );

    //eslint-disable-next-line
  }, []);

  const handleMembers = (member) => {
    setSelectMembers({
      ...filterData,
      [fieldName]: [member, ...selectMembers],
    });

    var result = allMembers.filter((allMember) => allMember.id !== member.id);
    setAllMembers(result);
    setShowMembers(false);
  };

  const removeMember = async (member) => {
    var result = selectMembers.filter(
      (allMember) => allMember.id !== member.id
    );
    try {
      await Promise.all([
        setSelectMembers({
          ...filterData,
          [fieldName]: result,
        }),
        setAllMembers([member, ...allMembers]),
      ]);
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <div className="membersInput">
      <Add
        className={classNames({
          addMemberSvg: true,
          disablePointer:
            fieldName === "taggedMembers" && !filterData.type_id.includes(8),
        })}
        onClick={() => setShowMembers(!showMembers)}
      />
      <Scrollbar
        style={{
          width: "97.5%",
        }}
      >
        {selectMembers.length !== 0 && (
          <div className="typeOption">
            {selectMembers.map((member) => (
              <span key={member.id} className="allSelectMember">
                {member.full_name}
                <CancelIcon
                  className="removeMember"
                  onClick={() => removeMember(member)}
                />
              </span>
            ))}
          </div>
        )}
      </Scrollbar>
      <CSSTransition
        in={showMembers}
        timeout={300}
        unmountOnExit
        classNames="dropdown-element"
      >
        <ClickAwayListener onClickAway={() => setShowMembers(false)}>
          <div className="membersDetail">
            <Scrollbar
              style={{
                height: "90px",
              }}
            >
              {allMembers.map((member) => (
                <div
                  key={member?.id}
                  className="memberName"
                  onClick={() => handleMembers(member)}
                >
                  <img
                    src={member.avatar}
                    alt={member.full_name}
                    className="memberAvatar"
                  />
                  <span>{member.full_name}</span>
                </div>
              ))}
            </Scrollbar>
          </div>
        </ClickAwayListener>
      </CSSTransition>
    </div>
  );
};
